
export default {
  inheritAttrs: false
}
